export const getVisible = (state) => state.loadingScreen.visible;
